module.exports = __webpack_public_path__ + "static/a00fcf47.card_1.png";